module.exports = __webpack_public_path__ + "static/media/circle-1.4d269935.svg";